import moment from 'moment'
import React,{useState,useEffect} from 'react'
import { useParams } from 'react-router-dom'
import { assetUrl } from '../../helpers'
import { Notification } from '../../sdk'
import { Loader } from '../Default'
import { DatePicker } from '../Default'
import { DataTable } from '../Default/DataTables/DataTable'


export const MainContent=()=> {
  const [state,setState]=useState({loader:true,date:moment().format("yyyy-MM-DD"),type:"",data:[],tbHeader:[{title:"#",name:"count"},{title:"Notification",name:"time"},{title:"Image",name:"date"},{title:"Time Ago",name:"date"}],updated:false,tableLoader:true});
  const params=useParams();
  const apiData=async(type)=>{
    try{
      
    let result=await new Notification().getAllNotification({type});
    
    if(result.length){
      let arr=[];
      let count=1;
      for(let val of result){
       arr.push([count,val.text,`<img src=${assetUrl}${val.imgUrl} style="width:100%"/>`,moment(val.createdAt).fromNow()])
       count++;
      }
      setState((pre)=>{
        return {...pre,data:arr,loader:false,tableLoader:false}
     })
    }
    else{
      
      setState((pre)=>{
        return {...pre,data:[],loader:false,tableLoader:false}
     })
    }
   
    }catch(e){
      console.log(e)
    alert("error occur")
    }

}
const onHandlerMonth=(month)=>{
  setState((pre)=>{
    return {...pre,tableLoader:true}
  })
  apiData(moment(month).format("yyyy-MM-DD"),state.type,true)
}
const onHandlerType=(event)=>{
  setState((pre)=>{
    return {...pre,tableLoader:true}
  })
  apiData(state.date,event.target.value===""?0:event.target.value,true);
}

useEffect(()=>{
  console.log(params.type)
  if(["anpr","fr"].includes(params.type)){
    apiData(params.type);
  }
  else{
    
  }

},[params.type])
if(!state.loader){
  return (
    <>
      <div className="card mb-3">
       {/* BEGIN card-body */}
       <div className="card-body">
   <div className="col-12">
     <div className="row">
       <div className="col-8">
       <div className="fw-bold mb-3">
   <span className="flex-grow-1 text-white">{params.type} Notifcations</span>
   </div> 
       </div>
       {/* <div className="col-2">
      <div class="form-group mb-3">
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect1" >Select Type</label>
        <select class="form-select" id="exampleFormControlSelect1" onChange={onHandlerType}>
          <option value="">Default</option>
          <option value="enter">Enter</option>
          <option value="exit">Exit</option>
          </select>
          </div>
       </div> */}
       {/* <div className="col-2">
   <DatePicker type="Anpr" name="Select Date" date={moment().subtract(1, 'day').format()} startDate={moment("2017").startOf('year').format()} endDate={moment().subtract(1, 'day').format()} handler={onHandlerMonth}/>
   </div> */}
     </div>
  
   </div>
   {state.tableLoader && <><Loader/></>}
   
   <div className="col-12">
  <DataTable headers={state.tbHeader} data={state.data} image={true} updated={state.updated}/>
  
   </div>
   </div>
   <div className="card-arrow">
         <div className="card-arrow-top-left" />
         <div className="card-arrow-top-right" />
         <div className="card-arrow-bottom-left" />
         <div className="card-arrow-bottom-right" />
       </div>
   </div>
   <div class="modal" id="showImg">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      
      <div class="modal-body">
       <img id="modalImage" src='' alt="nothing" style={{width:"100%"}}/>
      </div>
     
    </div>
  </div>
</div>


 </>
 
    
   )
}
else{
  return (<>
  <Loader/>
  </>)
}
  
}
